import { render, staticRenderFns } from "./Comp27t2.vue?vue&type=template&id=0db6e50a&scoped=true&"
import script from "./Comp27t2.vue?vue&type=script&lang=js&"
export * from "./Comp27t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp27t2.vue?vue&type=style&index=0&id=0db6e50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6e50a",
  null
  
)

export default component.exports